<button
  [type]="type"
  class="button"
  [attr.disabled]="disabled ? 'disabled' : null"
  (click)="handleButtonClicked($event)"
>
  {{ text }}
</button>
